<script>
	import Router from 'svelte-spa-router';
	import routes from './routes';
	import { lang } from './store';
	import { detectedLang } from './detectedLang.js';

	let langs = ['En', 'Fr', 'He', 'Ar', 'Ru', 'Es'];

	if (langs[detectedLang] != 'undefined') {
        lang.set(detectedLang);
        //console.log('2:' + detectedLanguage);
    }
</script>
<div id="background">
<center>	
<header><img id="logo" src='images/logoEDOmedicWhite.png' alt="Logo EDOmedic" />
	<select bind:value={$lang}>
		{#each langs as alang}
			<option value={alang}>
				{alang}
			</option>
		{/each}
	</select>
</header>
</center>
<main>
	<Router {routes} />
</main>
</div>
<style>
	#background {
		background: linear-gradient(270deg, rgba(66, 180, 231, 0.9) 0%, rgba(86, 191, 149, 0.9) 100%);
		align-content: center;
	}
	#logo {
		padding: 0px;
		width: 116px;
		height: 35px;
	}
	
	header {
		text-align: center;
		/* width: 484px; */
	}
	select {
		position: absolute;
		top: 8px;
		right: 8px;
		border: 1px solid #fff; 
		background-color: transparent;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        color: #FFFFFF;
	}
	main {
		text-align: center;
		padding: 12px;
		/* max-width: 240px; */
		margin: 0;
	}

	/* h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
	} */

	/* @media (min-width: 640px) {
		main {
			max-width: none;
		}
	} */
</style>